var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiddingHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.2311L9.20513 11.0259M9.20513 11.0259L11.8442 12.4894L16.7265 7.60649L12.6239 3.50457L7.74164 8.38745L9.20513 11.0259ZM4.4188 8.97466L12.6239 0.769531M11.2564 15.8116L19.4615 7.60649",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 19.2305H21.0006",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingHistory);
export default __webpack_public_path__ + "static/media/biddingHistory.457a4e6b201bb5fd6db40d1aa9e73201.svg";
export { ForwardRef as ReactComponent };